import * as React from "react";

const SearchIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.499 12.785a8.018 8.018 0 0 0-1.234-10.773A7.892 7.892 0 0 0 7.8.097a7.9 7.9 0 0 0-5.3 2.333A8.004 8.004 0 0 0 .187 7.767a8.012 8.012 0 0 0 1.907 5.499 7.885 7.885 0 0 0 10.702 1.235h-.002c.037.049.076.095.12.14l4.694 4.726a1.215 1.215 0 0 0 1.724 0 1.232 1.232 0 0 0 .001-1.735l-4.694-4.726a1.239 1.239 0 0 0-.14-.123v.002Zm.314-4.718a6.79 6.79 0 0 1-1.964 4.773 6.668 6.668 0 0 1-9.483 0 6.79 6.79 0 0 1 0-9.547 6.683 6.683 0 0 1 4.742-1.977c1.778 0 3.484.711 4.741 1.977a6.774 6.774 0 0 1 1.964 4.774Z"
      fill="currentColor"
    />
  </svg>
);

export default SearchIcon;
